/**
 * صفحة حذف الحساب والبيانات — السلوك.
 *
 * The page itself is readable signed out (that is what Google Play asks for);
 * only the button needs a session. `ErosSession` is the same signed-in check
 * the account pages use, and the request goes to commerce-worker, which
 * vouches for the customer to the deletion worker over a service binding.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-eros-data-deletion]');
    if (!root) return;

    var strings = window.ErosDataDeletionStrings || {};
    var button = root.querySelector('[data-deletion-submit]');
    var signedOut = root.querySelector('[data-deletion-signed-out]');
    var status = root.querySelector('[data-deletion-status]');

    var isSignedIn = !!(window.ErosSession && window.ErosSession.isSignedIn());
    if (button) button.hidden = !isSignedIn;
    if (signedOut) signedOut.hidden = isSignedIn;
    if (!isSignedIn || !button) return;

    button.addEventListener('click', function () {
      button.disabled = true;
      button.textContent = strings.sending || '…';
      if (status) status.textContent = '';

      window.ErosCommerce.request('/v1/account/deletion-request', {
        method: 'POST',
        auth: true,
        body: {},
      })
        .then(function (data) {
          button.hidden = true;
          if (status) {
            status.textContent = data && data.alreadyPending
              ? strings.already || ''
              : strings.done || '';
          }
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = strings.request || '';
          if (status) status.textContent = strings.error || '';
        });
    });
  });
})();
